module.exports = __webpack_public_path__ + "img/image110.4c2c6ae.jpg";